const { weekdays } = require('pando-constants');
const { omit } = require('lodash');
const moment = require('moment');
const MomentBusinessDays = require('./moment-business-days');

class MomentInitializer {
  static getHolidayAdjustedCalendar(holidayData) {
    const locale = {};
    if (holidayData) {
      const workingWeekdays = holidayData.weekly_holidays ?
        Object.values(omit(weekdays, holidayData.weekly_holidays)) :
        Object.values(weekdays);
      locale._workingWeekdays = workingWeekdays;
      if (holidayData.yearly_holidays) {
        const dateFormat = 'MM-DD-YYYY';
        const dates = holidayData.yearly_holidays.reduce((acc, obj) => {
          acc.push(moment(obj.date).format(dateFormat));
          return acc;
        }, []);
        locale._holidays = dates;
        locale._holidayFormat = dateFormat;
      }
    } else {
      // by default moment business considers only monday to friday as working days
      locale._workingWeekdays = Object.values(weekdays);
      locale._holidays = [];
    }
    const momentBusinessDays = new MomentBusinessDays(locale);
    return momentBusinessDays;
  }
}

module.exports = MomentInitializer;
